// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsShareAndroid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.244 5.957a1.01 1.01 0 0 1 .057.099 2 2 0 1 0-.058-.098zm-2.094.13A4.003 4.003 0 0 1 18 1a4 4 0 1 1-2.842 6.815L9.85 10.912a4.003 4.003 0 0 1 0 2.175l5.311 3.095a4 4 0 1 1-1.01 1.726l-5.309-3.094a4 4 0 1 1 0-5.63zm-6.45 4.86A1.999 1.999 0 0 0 4 12a2 2 0 1 0 3.7-1.053zM18 21a2 2 0 1 0-1.662-3.113 1.004 1.004 0 0 1-.123.21A2 2 0 0 0 18 21z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsShareAndroid;
